export const VARIABLE_CATEGORY_CODES = {
  CASING_PROFILE: ["QUALITY", "QUANTITY", "CONSTRUCTION", "GEOPHYSICS", "FLOW_TEST"],
  CONSTRUCTION_PROFILE: ["QUALITY", "QUANTITY", "CONSTRUCTION", "GEOPHYSICS", "FLOW_TEST"],
  DEPTH_MEASUREMENT_RECORD: ["QUALITY", "QUANTITY", "CONSTRUCTION", "GEOPHYSICS", "FLOW_TEST"],
  MONITORING: ["QUALITY", "QUANTITY", "CONSTRUCTION", "GEOPHYSICS", "FLOW_TEST"],
  FLOW_TEST_INTERPRETATION: ["QUALITY", "QUANTITY", "CONSTRUCTION", "GEOPHYSICS", "FLOW_TEST"],
  FLOW_TEST_MEASUREMENT: ["QUALITY", "QUANTITY", "CONSTRUCTION", "GEOPHYSICS", "FLOW_TEST"],
};
